///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/service-categories.collection.ts"/>
///<reference path="../collections/services.collection.ts"/>
///<reference path="../collection-population-strategies/service-to-category.strategy.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {
    import Manufacturer = Model.Manufacturer;


    export class ManufacturersCollection extends SmartMoverApiCollection<Manufacturer> implements IApiCollection<Manufacturer> {

        get url() {
            return 'manufacturer';
        }
    }

}
